import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'SV',
    name: 'Płonący Kor',
    id: 'TheBurningKor',
    health: 60,
    difficulty: 7,
    expeditionRating: 4,
    additionalInfo: '',
  },
]
